import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/to`


export const UploadTO = async (token, file) => {
  try{
    const formData = new FormData();
    formData.append('file', file)
    const response = await axios.post(`${API_URL}/upload/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    })
  return response.data
  }

  catch (error) {
    console.log(error)
  }
}


export const GetTOSByDate = async (token, startDate, endDate, restaurantId) => {

    let body = {
        start_date: startDate,
        end_date: endDate,
        restaurant_id: restaurantId
    }

    const response = await axios.post(`${API_URL}/tos/`, body,{
        headers: {
        Authorization: `Bearer ${token}`
        }
    });
  return response.data
};

export const DeleteTOS = async (token, listId) => {


    const response = await axios.post(`${API_URL}/delete/`, listId,{
        headers: {
        Authorization: `Bearer ${token}`
        }
    });
  return response.data
};